<template>
  <div class="text-center">
    <v-dialog
      v-model="showLoader"
      persistent
      width="30%"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  props: ['visible'],
  data: () => ({
    showLoader: false,
  }),
  watch: {
    visible: {
      handler(newValue) {
        setTimeout(() => {
          this.showLoader = newValue;
        },50);
      },
      deep: true
    }
  }
};
</script>

<style scoped>

</style>
